import { useState, useEffect } from "react";

export function useThemeColor() {
  const getThemeColor = () =>
    getComputedStyle(document.body).getPropertyValue("--bs-theme").trim() || "#08b0af";
  const [color, setColor] = useState(getThemeColor());
  useEffect(() => {
    const handle = () => setColor(getThemeColor());
    window.addEventListener("theme-reload", handle);
    return () => window.removeEventListener("theme-reload", handle);
  }, []);
  return color;
}
